import React from 'react';

import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';
import { CeilingHeight } from '@search/filter-enums/enums/CeilingHeight';

import { CellHeightFilter } from '../../../models/Filter';

interface ICeilHeightNewFilterView {
    filter: CellHeightFilter;
    handleChange: (value: CellHeightFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<CeilingHeight>[] = [
    { label: 'от 2,5 м', value: CeilingHeight.FROM_2_5 },
    { label: 'от 2,7 м', value: CeilingHeight.FROM_2_7 },
    { label: 'от 3 м', value: CeilingHeight.FROM_3 },
];

export const CeilHeightNewFilterView: React.FC<ICeilHeightNewFilterView> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: CeilingHeight) => {
        value ?
            handleChange(new CellHeightFilter(optionType)) :
            handleChange(new CellHeightFilter(CeilingHeight.UNKNOWN));
    }, [ handleChange ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ value, label }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.value === value}
                        onChange={v => onChange(v, value)}
                        variant='filter'
                        dataTest='ceil-height'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
